// removed by extract-text-webpack-plugin
module.exports = {"root":"styles__root___2h6Ll","rootSuccess":"styles__rootSuccess___2B3BK","textSuccess":"styles__textSuccess___RCg9r","action":"styles__action___3bKki","actions":"styles__actions___2yIik"};


//////////////////
// WEBPACK FOOTER
// ./src/components/RepairWizard/components/ModalMassive/styles.css
// module id = 2783
// module chunks = 0